<template>
    <b-modal id="bv-modal-manage-queues" size="lg" title="Gerenciar Filas" class="p-1" scrollable centered hide-footer>
        <div class="all-buttons">
            <button @click="toggleLogoffAll" type="button" class="btn btn-sm"
                :class="allLoggedOut ? 'btn-primary' : 'btn-danger'" style="border-radius: 5px !important;">
                {{ allLoggedOut ? 'Logar Todas' : 'Deslogar Todas' }}
            </button>

            <button @click="togglePauseAll" type="button" class="btn btn-warning btn-sm"
                style="border-radius: 5px !important;" v-if="!allLoggedOut">
                {{ onePause || allPaused ? 'Despausar Todas' : 'Pausar Todas' }}
            </button>
        </div>

        <b-table id="tbModalQueues" small striped bordered fixed head-variant="dark" :hover="true" :per-page="perPage"
            :fields="fields" :items="filteredItems" responsive="sm" class="mt-2" :current-page="currentPage" show-empty>

            <template #empty="scope">
                <h6 class="text-center">NENHUM USUÁRIO DISPONÍVEL</h6>
            </template>

            <template #cell(action)="data">
                    <button v-show="data.item.status == 'Logado'" @click="loginLogoff(data.item)" type="button"
                        class="btn btn-danger btn-sm" style="border-radius: 5px !important;">
                        Deslogar
                    </button>

                    <button v-show="data.item.status == 'Logado'" @click="openPauseModal([data.item])" type="button"
                        class="btn btn-warning btn-sm" style="border-radius: 5px !important;">
                        Pausar
                    </button>

                    <button v-show="data.item.status == 'Pausa'" @click="pauseQueue(data.item)" type="button"
                        class="btn btn-warning btn-sm" style="border-radius: 5px !important;">
                        Despausar
                    </button>

                    <button v-show="data.item.status == 'Deslogado'" @click="loginLogoff(data.item)" type="button"
                        class="btn btn-primary btn-sm" style="border-radius: 5px !important;">
                        Logar
                    </button>
            </template>

            <b-pagination v-model="currentPage" pills :total-rows="rows" :per-page="perPage" aria-controls="tbDetails"
                size="sm" align="right">
            </b-pagination>
        </b-table>

        <b-modal id="pause-modal" size="md" title="Selecionar Pausa" hide-footer centered>
            <div class="pause-buttons d-flex flex-column">
                <button v-for="pause in getPauses" :key="pause.id" @click="selectPause(pause.id, pause.name)" class="btn pause-button mb-2">
                    {{ pause.name }}
                </button>
            </div>
        </b-modal>
    </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    data: () => ({
        dataModal: [],
        fields: [
            { key: 'name', label: 'Fila', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
            { key: 'status', label: 'Status', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
            { key: 'action', label: 'Ação', class: 'text-center align-middle', sortable: true, thStyle: { 'font-weight': 'bold' } },
        ],
        calls: [],
        currentPage: 1,
        perPage: 100,
        queues: [],
        users: [],
        searchInput: '',
        items: [],
        myExtension: '',
        myID: 0,
        onePause: false,
        allPaused: false,
        allLoggedOut: false,
        selectedQueues: [],
        pauseState: {
            pauseReason: null,
            pauseApiSent: false,
            unpauseApiSent: false
        }
    }),
    methods: {
        ...mapActions(['setModalPause', 'fetchPauses', 'sendPauseApi', 'sendUnpause']),

        getTime() {
            let d = new Date();
            return d.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
        },

        selectPause(id, pause) {
            let time = this.getTime();

            if (!this.pauseState.pauseReason) {
                this.pauseState.pauseReason = pause;
                this.updatePauseState();
            }

            this.selectedQueues.forEach(queue => {
                this.pauseQueue(queue, this.pauseState.pauseReason);
            });

            this.$bvModal.hide('pause-modal');

            if (!this.pauseState.pauseApiSent) {
                let x = {
                    pauseId: this.pauseState.pauseReason,
                    tempo: `${time}`,
                    userId: this.myID,
                };

                this.sendPauseApi(x);
                this.pauseState.pauseApiSent = true;
                this.updatePauseState();
            }
        },

        pauseQueue(queue, reason) {
            let statusPause = "Pausa";

            if (queue.status === "Logado") {
                this.onePause = true;
                this.$emit("emitModalQueuePause", {
                    extension: this.myExtension,
                    queue: queue.name,
                    reason: reason
                });
            } else if (queue.status === "Pausa") {
                statusPause = "Logado";
                this.onePause = false;
                this.$emit("emitModalQueueUnPause", {
                    id: this.myID,
                    queue: queue.name,
                    extension: this.myExtension,
                });

                if (!this.pauseState.unpauseApiSent) {
                    let time = this.getTime();
                    let x = {
                        pauseId: this.pauseState.pauseReason,
                        tempo: `${time}`,
                        userId: this.myID,
                    };

                    this.sendUnpause(x);
                    this.pauseState.unpauseApiSent = true;
                    this.updatePauseState();
                }
            }

            this.items = this.items.map(el => {
                if (el.name === queue.name) el.status = statusPause;
                return el;
            });

            this.updateAllStatus();
        },

        openModal(item) {
            if (item && Array.isArray(item.queues)) {
                this.items = item.queues;
                this.myExtension = item.extension;
                this.myID = item.id;

                this.pauseState = JSON.parse(localStorage.getItem(`pauseState_${this.myID}`)) || {};

                this.updateAllStatus();
                this.$bvModal.show('bv-modal-manage-queues');
            }
        },

        loginLogoff(queue) {
            let currentStatus = "Deslogado";
            if (queue.status == "Logado") {
                this.$emit("emitModalQueueRemove", {
                    extension: this.myExtension,
                    queue: queue.name
                });
            } else {
                currentStatus = "Logado";
                this.$emit("emitModalQueueAdd", {
                    extension: this.myExtension,
                    queue: queue.name
                });
            }

            this.items = this.items.map(el => {
                if (el.name == queue.name) el.status = currentStatus;
                return el;
            });

            this.updateAllStatus();

            if (this.allLoggedOut) {
                this.pauseState = {
                    pauseReason: null,
                    pauseApiSent: false,
                    unpauseApiSent: false
                };
                localStorage.removeItem(`pauseState_${this.myID}`);
            }
        },

        openPauseModal(queues) {
            this.selectedQueues = queues || this.items.filter(queue => queue.status === 'Logado');
            if (this.selectedQueues.length > 0) {
                if (!this.pauseState.pauseReason) {
                    this.$bvModal.show('pause-modal');
                    this.fetchPauses();
                } else {
                    this.selectPause(null, this.pauseState.pauseReason);
                }
            }
        },

        togglePauseAll() {
            if (this.onePause || this.allPaused) {
                this.items.forEach(queue => {
                    if (queue.status === 'Pausa') {
                        this.pauseQueue(queue);
                    }
                });
            } else {
                this.openPauseModal();
            }
            this.updateAllStatus();
        },

        toggleLogoffAll() {
            if (this.allLoggedOut) {
                this.items.forEach(queue => {
                    if (queue.status === 'Deslogado') {
                        this.loginLogoff(queue);
                    }
                });
            } else {
                this.items.forEach(queue => {
                    if (queue.status === 'Logado') {
                        this.loginLogoff(queue);
                    }
                });
            }
            this.updateAllStatus();
        },

        updateAllStatus() {
            this.allPaused = this.items.every(queue => queue.status === 'Pausa');
            this.allLoggedOut = this.items.every(queue => queue.status === 'Deslogado');
            this.onePause = this.items.some(queue => queue.status === 'Pausa');

            if (!this.onePause) {
                this.pauseState = {
                    pauseReason: null,
                    pauseApiSent: false,
                    unpauseApiSent: false
                };
                localStorage.removeItem(`pauseState_${this.myID}`);
            } else {
                this.updatePauseState();
            }
        },

        updatePauseState() {
            localStorage.setItem(`pauseState_${this.myID}`, JSON.stringify(this.pauseState));
        }
    },
    computed: {
        ...mapGetters(['getPauses']),
        rows() {

        return this.items.filter(item => item.end !== false).length;
        },
        filteredItems() {
        // Aqui, filtramos os itens que serão exibidos na tabela
        return this.items.filter(item => item.end !== false);
    }

    },
    mounted() {
        this.pauseState = JSON.parse(localStorage.getItem(`pauseState_${this.myID}`)) || {};
    }
};
</script>






<style scoped>
.all-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
}

.pause-buttons {
    padding: 0 20px;
}

.pause-button {
    border-radius: 8px;
    background-color: #f8f9fa;
    color: #495057;
    border: none;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23); /* Adiciona a box-shadow */
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
    width: 100%;
    padding: 15px;
    text-align: center;
    margin-bottom: 10px;
}

.pause-button:hover {
    background-color: #e2e6ea;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.16), 0 6px 12px rgba(0, 0, 0, 0.23);
}
</style>
